import React from "react";
import { TouchableOpacity, Text, View, StyleSheet } from "react-native";
import { Ionicons } from "@expo/vector-icons";

const DEFAULT_COLOR = "#4d2c1d";
const DEFAULT_VALUE_COLOR = "#6b7280";
const DEFAULT_CHEVRON_COLOR = "#9ca3af";
const SPEEDRAILZ_COLOR = "#92400e";

/**
 * A row button that opens a bottom sheet. Used for Tag people, Who can see this,
 * Rating, and SpeedRailz ratings on the Check-in screen.
 *
 * @param {string} icon - Ionicons name (e.g. "people-outline", "eye-outline")
 * @param {string} label - Left label (e.g. "Tag people", "Who can see this?")
 * @param {string} [value] - Right-side value text (ignored if rightContent is provided)
 * @param {React.ReactNode} [rightContent] - Optional custom right-side content (e.g. stars + label)
 * @param {function} onPress - Called when the row is pressed (e.g. open sheet)
 * @param {"default"|"speedRailz"} [variant="default"] - "speedRailz" for yellow styling
 */
function ButtonToBottomSheet({ icon, label, value, rightContent, onPress, variant = "default" }) {
  const isSpeedRailz = variant === "speedRailz";
  const iconColor = isSpeedRailz ? SPEEDRAILZ_COLOR : DEFAULT_COLOR;
  const chevronColor = isSpeedRailz ? SPEEDRAILZ_COLOR : DEFAULT_CHEVRON_COLOR;

  return (
    <TouchableOpacity
      style={[styles.row, isSpeedRailz && styles.rowSpeedRailz]}
      onPress={onPress}
      activeOpacity={0.7}
    >
      <Ionicons name={icon} size={22} color={iconColor} />
      <Text style={[styles.label, isSpeedRailz && styles.labelSpeedRailz]}>{label}</Text>
      {rightContent != null ? (
        <View style={styles.rightContent}>{rightContent}</View>
      ) : (
        <Text style={[styles.value, isSpeedRailz && styles.valueSpeedRailz]}>{value}</Text>
      )}
      <Ionicons name="chevron-forward" size={20} color={chevronColor} />
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  row: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "#fff",
    borderRadius: 12,
    paddingHorizontal: 16,
    paddingVertical: 14,
    marginTop: 12,
  },
  rowSpeedRailz: {
    backgroundColor: "#FEF9E7",
    borderWidth: 2,
    borderColor: "#FBBF24",
  },
  label: {
    marginLeft: 12,
    fontSize: 16,
    color: DEFAULT_COLOR,
  },
  labelSpeedRailz: {
    color: SPEEDRAILZ_COLOR,
    fontWeight: "600",
  },
  rightContent: {
    flex: 1,
    marginRight: 8,
    alignItems: "flex-end",
    justifyContent: "center",
  },
  value: {
    flex: 1,
    fontSize: 16,
    color: DEFAULT_VALUE_COLOR,
    marginRight: 8,
    textAlign: "right",
  },
  valueSpeedRailz: {
    color: SPEEDRAILZ_COLOR,
  },
});

export default ButtonToBottomSheet;
